<template>
  <div>
    <LittleBanner />
    <p class="head-title">考务问答</p>
    <div class="ques-content">
      <el-form label-width="80px">
        <el-form-item label="问题标题">
          <div class="text-line input-text">{{ quesObj.title }}</div>
        </el-form-item>
        <el-form-item label="提交时间">
          <div class="text-line">{{ quesObj.createTime }}</div>
        </el-form-item>
        <el-form-item label="具体描述">
          <div class="text-line input-text">{{ quesObj.question }}</div>
        </el-form-item>
        <el-form-item label="附件图片">
          <div class="image-content">
            <el-image
              v-for="(obj, index) in photos"
              :key="index"
              style="width: 100px; height: 100px;margin: 0 10px 10px 0;"
              :src="obj" 
              :preview-src-list="photos">
            </el-image>
          </div>
        </el-form-item>
        <div v-if="quesObj.answer" class="el-form-item">
          <label class="el-form-item__label" style="width: 80px;color: #01C05D;">平台回复</label>
          <div class="el-form-item__content" style="margin-left: 80px;">
            <div class="text-line input-text">{{ quesObj.answer }}</div>
          </div>
        </div>
      </el-form>
      <div style="text-align: center">
        <el-button type="primary" @click="backList">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/utils/index'
import { getDatailById } from '@/api/ques'
import LittleBanner from '../layout/components/LittleBanner'
export default {
  name: 'Form',
  data() {
    return {
      imgIp: config.imgIp,
      id: null,
      quesObj: {},
      photos: []
    }
  },
  components: {
    LittleBanner
  },
  mounted() {
    this.id = this.$route.query.id
    this.getDataById()
  },
  methods: {
    getDataById() {
      let that = this
      getDatailById(this.id)
        .then(res => {
          if (res.code === 200) {
            that.quesObj = res.data
            if (that.quesObj.photos) {
              let arr = that.quesObj.photos.split(',')
              arr.forEach(element => {
                that.photos.push(that.imgIp + element)
              });
            }
          }
        })
    },
    backList() {
      this.$router.push('/ques/list')
    }
  }
}
</script>

<style lang="scss" scoped>
.ques-content {
  max-width: 1200px;
  margin: 20px auto;
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}
.head-title {
  max-width: 1240px;
  margin: 30px auto 15px;
  font-size: 16px;
  font-weight: bold;
}
.input-text {
  background-color: #F5F7FA;
  border-radius: 2px;
  border: 1px solid #DCDFE6;
  padding: 9px 10px;
  line-height: 22px;
  max-width: 600px;
}
</style>
